import { ISSUE_ATTRIBUTE_NAMES } from './issue-attribute-names';
export const PANELS = {
  FIRST_PANEL: 'FIRST_PANEL',
  SECOND_PANEL: 'SECOND_PANEL',
};

export const ISSUES_PREVIEW_FIELD_NAMES = {
  [PANELS.FIRST_PANEL]: [ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO, ISSUE_ATTRIBUTE_NAMES.DUE_DATE, ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS],
  [PANELS.SECOND_PANEL]: [ISSUE_ATTRIBUTE_NAMES.COST, ISSUE_ATTRIBUTE_NAMES.SCHEDULE],
};
